import PageCaption from './PageCaption'

export default PageCaption
